<form id="permanent_planning_filters" [formGroup]="this.filtersPermanentPlanningForm" (ngSubmit)="this.search()">
    
    <div id="permanent_planning_filters_list">
        
        <marv-select 
            label="{{ 'SECTORS' | translate }}" 
            icon="trail-sign-outline" 
            formName="sectorsIds"            
            [externalSource]="this.sectorsExternalSource"
            [multiple]="true"
            [withSpeechToText]="true"
        ></marv-select>
        
        <marv-select 
            label="{{ 'RETAILERS' | translate }}" 
            icon="cart-outline" 
            formName="retailersIds"            
            [externalSource]="this.retailersExternalSource"
            [multiple]="true"
            [withSpeechToText]="true"
        ></marv-select>
                
        <marv-select 
            label="{{ 'RANKINGS' | translate }}" 
            icon="podium-outline" 
            formName="rankingsIds"            
            [externalSource]="this.rankingsExternalSource"
            [multiple]="true"
            [withSpeechToText]="true"
        ></marv-select>
                
        <marv-select 
            label="{{ 'STORE_PROFILS' | translate }}" 
            icon="storefront-outline" 
            formName="profilsIds"            
            [externalSource]="this.profilsExternalSource"
            [multiple]="true"
            [withSpeechToText]="true"
        ></marv-select>
        
        @if(this.allowedForAreaScheduling){  
            <marv-toggle label="{{'DISPLAY_ALL_AREA_SECTORS' | translate}}" formName="displayAllAreaSectors" labelPlacement="end" />            
        }
       
    </div>
    
    <ion-grid id="footer_permanent_planning_filters">
        <ion-row class="ion-justify-content-around">
            <ion-col size="auto">
                <marv-button type="submit" label="{{ 'SEARCH' | translate }}" icon="search-outline" color="primary" />
            </ion-col>
            <ion-col size="auto">
                <marv-button type="button" label="{{ 'DISPLAY_ALL' | translate }}" icon="refresh-outline" color="secondary" (click)="this.displayAll()" />
            </ion-col>
        </ion-row>
    </ion-grid>
    
</form>